import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../../service.service';

interface Department {
  department_id: string;
  department_name: string;
}

interface Employee {
  employee_id: string;
  employee_name: string;
}

@Component({
  selector: 'app-master-for-rfr-edit',
  templateUrl: './master-for-rfr-edit.component.html',
  styleUrls: ['./master-for-rfr-edit.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MasterForRfrEditComponent implements OnInit {

  departmentId: string = '';
  departmentName: string = '';


  departments: Department[] = [];
  employees: Employee[] = [];
  employeeSearch: string = '';
  filteredEmployees: Employee[] = [];

  selectedDepartmentId: string = '';
  selectedEmployeeId: string = '';

  isLoadingDepts = false;
  isLoadingEmps = false;
  isSaving = false;

  loadError: string | null = null;
  successMessage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ServiceService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.departmentId = params['department_id'] || '';
      this.selectedDepartmentId = this.departmentId;
    });
    this.loadDepartments();
    this.loadEmployees();
  }

  loadDepartments(): void {
    this.isLoadingDepts = true;
    this.apiService.ViewDepartments().subscribe({
      next: (res: any) => {
        this.isLoadingDepts = false;
        if (res && res.success && Array.isArray(res.data)) {
          this.departments = res.data;
          const matchedDept = this.departments.find(dept => dept.department_id === this.departmentId);
          if (matchedDept) {
            this.departmentName = matchedDept.department_name;
          }
        }
      },
      error: () => {
        this.isLoadingDepts = false;
        this.loadError = 'Failed to load departments.';
      }
    });
  }

  loadEmployees(): void {
    this.isLoadingEmps = true;
    this.apiService.ViewAllEmployee().subscribe({
      next: (res: any) => {
        this.isLoadingEmps = false;
        if (res && (res.success || res.sucess) && Array.isArray(res.data)) {
          this.employees = res.data;
          this.filteredEmployees = [...this.employees];
        }
      },
      error: () => {
        this.isLoadingEmps = false;
        this.loadError = 'Failed to load employees.';
      }
    });
  }
  filterEmployees(): void {
  const search = this.employeeSearch.toLowerCase().trim();
  this.filteredEmployees = this.employees.filter(emp =>
    emp.employee_name.toLowerCase().includes(search)
  );
}

  onSave(): void {
    // if (!this.selectedDepartmentId || !this.selectedEmployeeId) {
    //   this.loadError = 'Please select both department and employee.';
    //   return;
    // }

    this.isSaving = true;
    this.loadError = null;
    this.successMessage = null;

    const body = {
      department_id: this.selectedDepartmentId,
      rfr_responsible_employee_id: this.selectedEmployeeId || null
    };

    this.apiService.UpdateRfrResponsibleEmployee(body).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        if (res && res.success) {
          this.successMessage = 'Updated successfully!';
          setTimeout(() => {
            this.router.navigate(['/admin/rfr-responsible-listing']);
          }, 1500);
        } else {
          this.loadError = 'Update failed. Please try again.';
        }
      },
      error: () => {
        this.isSaving = false;
        this.loadError = 'Failed to update. Please try again.';
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/admin/rfr-responsible-listing']);
  }
  clearEmployeeSelection(): void {
  this.selectedEmployeeId = '';
}
}